export default function useCurrencyFormat(amount: number | undefined): string {
  return amount === undefined ? "?" : amount.toLocaleString("ko-KR");
}
